import { render, staticRenderFns } from "./rsvAlimModi.vue?vue&type=template&id=2f716661"
import script from "./rsvAlimModi.vue?vue&type=script&lang=js"
export * from "./rsvAlimModi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports